import { instance } from "./index";

const API_PATH = "/inquire";
const inquireManager = {
    sendMail: (data) => {
        return instance.post(`${API_PATH}/send`, data);
    },
    uploadImage: (formData) => {
        return instance.post(`${API_PATH}/upload`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
};

export default inquireManager;
